import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div
      className="Robustand twod-services p-100"
      style={{ backgroundColor: "#F9F9F9" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={5} xxl={5}>
            <h2>
              2D <span>Game Development</span> Services We Provide
            </h2>
            <p>
              We offer full-fledged 2D game development services. From asset
              designing to gameplay development and actual physics to responsive
              controls, our game production experts deliver excellence in every
              project for high-performance experiences.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Start with a Free Consultation
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>Visual Conceptualization</h4>
                  <p>
                    Translate your game’s vision into actionable design with
                    cohesive and dynamic visual frameworks that shape the entire
                    2D game experience.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Character Design & Animation</h4>
                  <p>
                    Craft and animate characters with high precision, focusing
                    on unique traits and movements that drive player connection
                    and narrative immersion.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Environment Design</h4>
                  <p>
                    Design richly detailed 2D game environments that enhance
                    player interaction and strategically support the game’s core
                    mechanics.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Gameplay Programming</h4>
                  <p>
                    Write and optimize code to bring game mechanics to life,
                    ensuring smooth transitions, real-time player interactions,
                    and seamless integration of character controls, physics, and
                    UI elements, tailored to the unique requirements of 2D game
                    development.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Level Scripting & Logic Development</h4>
                  <p>
                    Design and implement level logic, event triggers, and
                    scripted sequences to guide the player's progression,
                    creating engaging challenges, puzzles, and interactions that
                    align with the game's narrative and mechanics.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Dynamic Art & Animation</h4>
                  <p>
                    Implement advanced 2D art and animation techniques, bringing
                    your game’s world and characters to life with impactful
                    visual storytelling.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Mechanics Implementation</h4>
                  <p>
                    Develop and refine core game mechanics to ensure seamless,
                    responsive gameplay, aligning with the player’s expectations
                    and genre standards.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Cross-Platform Optimization</h4>
                  <p>
                    Port your 2D game to multiple platforms with tailored
                    optimizations, guaranteeing smooth performance and expanding
                    your market reach.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
